import React, {useState, useEffect}from 'react';
import Select from "react-select";
import {findObjInArr} from "@app/utils/CommonFunctions";
import * as mainService from '@app/services/mainService';

const GuikemListComponent = ({onChange, disable, value,tableName,id_tableName,isMulti, required,labelName, name}) => {
    
    const [listColor, setListColor] = useState([]);

      useEffect(async () => {
            
            const cqtemp = await mainService.getAllGuikem({ tableName: tableName,id_tableName: id_tableName });
            setListColor(cqtemp);

        }, []);

    return  <>
                                        <label className={ required? required : "" }>{labelName ? labelName: "Gửi kèm"}</label>
                                        <Select
                                            isSearchable={false}
                                            isMulti={isMulti}
                                            isClearable
                                            name={name ? name: "guikem_fks"}

                                            onChange={onChange}
                                            value={value}
                                            options={listColor}
                                            isDisabled={disable}
                                        />
                                       
                                    </>
};

export default GuikemListComponent;
